import React from 'react';

function TaskSearchBar() {
  return (
    <div className='dt-search pull-right mt-0'>
      <input type="search" className='form-control input-sm pull-right' placeholder={I18n.t('search')} id='datagridGlobalFilterInput' autoComplete='off' />
    </div>
  )

}

export default TaskSearchBar;